import React from 'react';
import BookMarkedRecipes from "./BookMarkedRecipes"

const BookMarkRecipeLayout = () => {
    return (
        <>
            <BookMarkedRecipes/>
        </>
    );
};

export default BookMarkRecipeLayout;